import {useEffect, useState, useCallback} from '@wordpress/element';
import {create as createDropin} from '@braintree/dropin';

export const DropinForm = ({options, setDropinInstance}) => {
    const {clientToken, locale = 'en_US'} = options;
    const [error, setError] = useState(null);
    const [element, setElement] = useState(null);
    const setRef = useCallback(node => {
        if (node) {
            setElement(node);
        }
    });
    useEffect(() => {
        if (element) {
            createDropin({
                authorization: clientToken,
                container: element,
                locale: locale
            }, (error, dropinInstance) => {
                if (error) {
                    setError(error?.message);
                } else {
                    setDropinInstance(dropinInstance);
                }
            })
        }
    }, [element]);
    return (
        <>
            {error && <div className={'wc-braintree-blocks__error'}>{error}</div>}
            <div ref={setRef} className={'wc-braintree-blocks-dropin__form'}>

            </div>
        </>
    )

}

export default DropinForm;